export const columnsToHideForMobile = {
    CRNS: false,
    CRN: false
}